import { render, staticRenderFns } from "./EnrollFee.vue?vue&type=template&id=d25d42f8"
import script from "./EnrollFee.vue?vue&type=script&lang=js"
export * from "./EnrollFee.vue?vue&type=script&lang=js"
import style0 from "./EnrollFee.vue?vue&type=style&index=0&id=d25d42f8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d25d42f8')) {
      api.createRecord('d25d42f8', component.options)
    } else {
      api.reload('d25d42f8', component.options)
    }
    module.hot.accept("./EnrollFee.vue?vue&type=template&id=d25d42f8", function () {
      api.rerender('d25d42f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/clinic/EnrollFee.vue"
export default component.exports